import styled from '@emotion/styled';
import { Box, Select } from '@mui/material';
import { neutralVariant } from '../../styles/themes';
import { shouldForwardProps } from '../../utils';
import { LabelLarge } from '../../styles';

const EllipsisText = styled(LabelLarge)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 204px;
    align-self: center;
`;

const FlexWrapper = styled(Box)`
    display: flex;
`;

const MultiSelectBaseSelect = styled(Select, shouldForwardProps)<{
    isSelected: boolean;
    noMaxWidth: boolean;
}>`
    width: fit-content;
    max-width: ${({ noMaxWidth }) => (noMaxWidth ? '' : '185px')};
    border-radius: ${({ theme }) => theme.spacing(1)};
    background-color: ${({ theme, isSelected }) =>
        isSelected ? theme.colors.primaryContainer : theme.colors.surface};
    height: 32px;

    & div {
        color: ${({ theme, isSelected }) =>
            isSelected ? theme.colors.onPrimaryContainer : neutralVariant[10]};
    }

    .MuiSelect-select {
        padding: ${({ theme, isSelected }) =>
            isSelected ? theme.spacing(1) : `${theme.spacing(1)} ${theme.spacing(2)}`};
    }

    .MuiOutlinedInput-notchedOutline {
        border: ${({ theme, isSelected }) =>
            `1px solid ${isSelected ? theme.colors.primaryContainer : theme.colors.outline}`};
        border-radius: ${({ theme }) => theme.spacing(1)};
    }
`;

export { EllipsisText, FlexWrapper, MultiSelectBaseSelect };
